import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import weatherWidgetService from "./weatherWidgetService";

const initialState = {
  weatherData: null,
  loadingWeather: false,
  errorWeather: null
};

export const getWeatherDataAction = createAsyncThunk(
  "weatherWidget/getWeatherData",
  async ({ latitude, longitude }, thunkAPI) => {
    return await weatherWidgetService.getWeatherData({ latitude, longitude });
  }
);

const weatherWidgetSlice = createSlice({
  name: "weatherWidget",
  initialState,
  reducers: {
    resetWeatherData: (state) => {
      state.weatherData = null;
      state.loadingWeather = false;
      state.errorWeather = null;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getWeatherDataAction.pending, (state) => {
      state.loadingWeather = true;
    });
    builder.addCase(getWeatherDataAction.fulfilled, (state, action) => {
      state.weatherData = action.payload;
      state.loadingWeather = false;
    });
    builder.addCase(getWeatherDataAction.rejected, (state, action) => {
      state.errorWeather = action.error.message;
      state.loadingWeather = false;
    });
  }
});

export const { resetWeatherData } = weatherWidgetSlice.actions;

export default weatherWidgetSlice.reducer;
